/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentPartResponse
 */
export interface EquipmentPartResponse {
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartResponse
     */
    equipmentId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartResponse
     */
    partId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartResponse
     */
    position?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartResponse
     */
    locationId?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartResponse
     */
    secondaryLocationId?: number;
    /**
     * 
     * @type {Date}
     * @memberof EquipmentPartResponse
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof EquipmentPartResponse
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof EquipmentPartResponse
     */
    group?: number;
}

/**
 * Check if a given object implements the EquipmentPartResponse interface.
 */
export function instanceOfEquipmentPartResponse(value: object): value is EquipmentPartResponse {
    return true;
}

export function EquipmentPartResponseFromJSON(json: any): EquipmentPartResponse {
    return EquipmentPartResponseFromJSONTyped(json, false);
}

export function EquipmentPartResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentPartResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'equipmentId': json['equipmentId'] == null ? undefined : json['equipmentId'],
        'partId': json['partId'] == null ? undefined : json['partId'],
        'position': json['position'] == null ? undefined : json['position'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'secondaryLocationId': json['secondaryLocationId'] == null ? undefined : json['secondaryLocationId'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'group': json['group'] == null ? undefined : json['group'],
    };
}

export function EquipmentPartResponseToJSON(json: any): EquipmentPartResponse {
    return EquipmentPartResponseToJSONTyped(json, false);
}

export function EquipmentPartResponseToJSONTyped(value?: EquipmentPartResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'equipmentId': value['equipmentId'],
        'partId': value['partId'],
        'position': value['position'],
        'locationId': value['locationId'],
        'secondaryLocationId': value['secondaryLocationId'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString().substring(0,10)),
        'externalId': value['externalId'],
        'group': value['group'],
    };
}

